import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { updateDashboardData } from '../../Redux/dashboardReducer';
import { useDispatch, useSelector } from "react-redux";
import BIPOC from '../../assets/images/home/BIPOC.jpg';
import Andropause from '../../assets/images/home/Andropause.jpg';
import Fertility from '../../assets/images/home/Fertility.jpg';
import BehavioralHealth from '../../assets/images/home/Behavioral_Health.jpg';
import CaregiverSupport from '../../assets/images/home/Caregiver_Support.jpg';
import ChildDevelopment from '../../assets/images/home/Child_Development.jpg';
import Maternity from '../../assets/images/home/Maternity.jpg';
import Menopause from '../../assets/images/home/Menopause.jpg';
import Nutrition from '../../assets/images/home/Nutrition.jpg';
import Preconception from '../../assets/images/home/Preconception.jpg';
import Surrogacy from '../../assets/images/support-services/surrogacy.jpg';
import Adoption from '../../assets/images/support-services/adoption.jpg';
import WomensHealth from '../../assets/images/home/Womens_Health.jpg';
import WINforHim from '../../assets/images/home/WIN_for_Him.jpg';
import LGBTQIA from '../../assets/images/home/LGBTQIA.jpg';
import Doulas from '../../assets/images/home/Doulas.jpg';
import GenderAfirm from '../../assets/images/home/Gender.png';
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from 'react-i18next';
import ErrorModal from "../Security/ErrorModal";
import MenopurModal from "../WINPay/MenopurWincard";
import AddAppointmentModal from "../../QuickAppoinmnet/AddAppointmentModal";
import { useSession } from '../../Redux/SessionContext';
import { updateIsJourneyChange } from "../../Redux/userReducer";
import { FeedbackConsent } from "../Registration/Feedback";

const Home_W = () => {
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  const navigate = useNavigate();
  const { t } = useTranslation();
  const email = useSelector((state) => state.email.email); // Getting the email from Redux store
  const userData = useSelector((state) => state); // Getting the email from Redux store
  const [blockData, setBlockData] = useState([]);
  const dispatch = useDispatch();

  const emailId = useSelector((state) => state.userData?.userData?.EmailID);
  const deviceType = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
  const userInfo = useSelector((state) => state.userData);
  const { pauseSession } = useSession();

  const normalizeWhyHere = (value) => {
    if (Array.isArray(value)) {
      return value.join(", ");
    }

    return typeof value === "string" ? value : "";
  };

  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [allAppointments, setAllAppointments] = useState([]);
  const [appointmentsLoading, setAppointmentsLoading] = useState(false);
  const [appointmentToCancel, setAppointmentToCancel] = useState(null);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const preferredNameRaw = userData?.userData?.userData?.PreferredName || userData?.registration?.registrationData?.PreferredName || "";
  const firstNameRaw = userData?.userData?.userData?.FirstName || userData?.registration?.registrationData?.FirstName || "";
  const journeyType = normalizeWhyHere(userData?.userData?.userData?.WhyHere || userData?.registration?.registrationData?.WhyHere);
  const appRatingFlag = userData?.userData?.userData?.APPRatingFlag || "";
  const [showFeedbackConsent, setShowFeedbackConsent] = useState(false);  

  const [appointments, setAppointments] = useState({
    date: null,
    time: null,
    duration: null,
    SlotType: null
  });
  const [treatmentStatus, setTreatmentStatus] = useState({
    description: "",
    status: "",
    requestedDate: "",
    MemberReqAuth: "",
    WINCentive: ""
  });
  const [prescription, setPrescription] = useState({
    description: "",
    status: "",
    requestedDate: "",
  });
  const location = useLocation();
  const subRedirection = location.state?.subRedirection || "";
  const updatedLink = location.state?.updatedLink || "";
  const mediaLink = location.state?.mediaLink || "";
  const nonPhysicianProvider = location.state?.nonPhysicianProvider || "";
  const slotType = location.state?.slotType || "";
  const advocateConsultType = location.state?.advocateConsultType || "";
  const token = localStorage.getItem('AccessToken');
  const [homeSections, setHomeSections] = useState([]);
  const [webinarLink, setWebinarLink] = useState(null);
  const [educationLink, setEducationLink] = useState(null);
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  // Carousel state
  const [itemsPerView, setItemsPerView] = useState(5);
  const [currentPosition, setCurrentPosition] = useState(0);
  const totalItems = blockData.length;
  const scrollCount = 1;
  const [memberReqAuth, setMemberReqAuth] = useState(""); // Store MemberReqAuth
  const [showMenopurModal, setShowMenopurModal] = useState(false);
  const [webinarList, setWebinarList] = useState([]);
  const [quickActions, setQuickActions] = useState([]);
  const [webinarRegistrations, setWebinarRegistrations] = useState([]);
  const [dashboardData, setDashboardData] = useState(null);
  // Virtual Network modal state
  const [showVirtualNetworkModal, setShowVirtualNetworkModal] = useState(false);
  const [virtualNetworkLink, setVirtualNetworkLink] = useState("");
  const [activeArrow, setActiveArrow] = useState("");

  //  Handler for Book a Virtual Consult button
  const handleBookConsultClick = () => {
    setShowAppointmentModal(true);
  };

  const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  const preferredName = capitalizeFirstLetter(preferredNameRaw);
  const firstName = capitalizeFirstLetter(firstNameRaw);

  //  Modal button handlers
  const handleYes = () => {
    setShowAppointmentModal(false);
    navigate("/appointment-booking");
  };

  const handleYesNoLongerPregnant = () => {
    setShowAppointmentModal(false);
    navigate("/pregnancy");
  };

  const handleNo = () => {
    setShowAppointmentModal(false);
  };

  const handleClose = () => {
    setShowAppointmentModal(false);
  };

  const closeModal = () => {
    setShowFeedbackConsent(false);
  };

  const handleArrowClick = (direction) => {
    // Return early if the button should be disabled
    if (direction === -1 && currentPosition === 0) return;
    if (direction === 1 && currentPosition >= totalItems - itemsPerView) return;

    setActiveArrow(direction);
    scrollCarousel(direction);

    // Clear active state after animation completes
    const timeoutId = setTimeout(() => {
      setActiveArrow("");
    }, 200); // Match this with CSS transition time

    return () => clearTimeout(timeoutId);
  };

  const getAndOpenMiraLink = async (serviceDescription, miraLink) => {
    const params = {
      EmailID: emailId,
      DeviceType: deviceType,
      Contract: userData?.userData?.userData?.ContractIdentified || userData?.registration?.registrationData?.ContractIdentified,
      MemberID: userData?.userData?.userData?.MemberID,
      ServiceDescription: serviceDescription,
      MiraLink: miraLink
    };

    try {
      const response = await axios.post(
        Endpoints.GetMiraLink,
        `_Params=${encodeURIComponent(JSON.stringify(params))}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.data && response.data != "") {
        window.open(response.data, "_blank");
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    const alreadyShown =
      sessionStorage.getItem("feedbackPromptShown");

    if (
      appRatingFlag === "Yes" &&
      !alreadyShown
    ) {
      setShowFeedbackConsent(true);
      sessionStorage.setItem("feedbackPromptShown", "true");
    }
  }, []);

  useEffect(() => {
      if (location && subRedirection != "") {
        navigate(subRedirection, { state: { updatedLink, mediaLink, nonPhysicianProvider, slotType, advocateConsultType }, replace: true })
      }
    }, [])
  
  // Handle iOS touch events
  useEffect(() => {
    const preventBounce = (e) => {
      // Only prevent bounce if touching carousel controls
      if (e.target.closest('.home-carousel-controls')) {
        e.preventDefault();
      }
    };

    document.addEventListener('touchmove', preventBounce, { passive: false });
    return () => document.removeEventListener('touchmove', preventBounce);
  }, []);

  useEffect(() => {
    document.addEventListener("touchstart", () => { }, true);
  }, []);

  useEffect(() => {
    if (isHighmarkPortal) {
      const handlePopState = (event) => {
        // If on /home, go forward to prevent going back to /login
        if (window.location.pathname === "/home") {
          window.history.go(1);
        }
      };
      window.addEventListener("popstate", handlePopState);
      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, [isHighmarkPortal, navigate]);
  useEffect(() => {
    // Only fetch data if the email and token are available
    console.log("Fetching dashboard data for email:", email);
    console.log("Using token:", token);
    const ssoFullUrl = sessionStorage.getItem("ssofullUrl");
    console.log("SSO Full URL from sessionStorage:", ssoFullUrl);

    if (email && token) {
      console.log("going to fetch dashboard data")
      const fetchDashboardData = async () => {
        setIsLoading(true); // Start loading
        try {
          const response = await axios.post(
            Endpoints.GetDashboardDetails,
            `_Params=${encodeURIComponent(JSON.stringify({ EmailID: email, DeviceType: deviceType }))}`,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const data = response.data;
          setDashboardData(data);
          if (!Array.isArray(data.HomeSections) || data.HomeSections.length === 0) {
            navigate("/login");
            return;
          }
          const { ServiceDetails, HomeSections, AppoinmentDetails, TreatmentDetails, PrescriptionDetails, EducationFeed, WebinarLink, Appointments } = data;
          dispatch(updateDashboardData(data));
          const getServiceImage = (serviceType) => {
            switch (serviceType) {
              case 'LGBTQIA+':
                return LGBTQIA
              case 'BIPOC':
                return BIPOC;
              case 'Maternity':
                return Maternity;
              case 'Fertility':
                return Fertility;
              case 'Preconception':
                return Preconception;
              case 'Behavioral Health':
                return BehavioralHealth;
              case 'Nutrition':
                return Nutrition;
              case 'Child Development':
                return ChildDevelopment;
              case 'Caregiver Support':
                return CaregiverSupport;
              case 'Menopause':
                return Menopause;
              case 'Andropause':
                return Andropause;
              case 'WIN for Him':
                return WINforHim;
              case 'Surrogacy':
                return Surrogacy;
              case 'Adoption':
                return Adoption;
              case "Women's Health":
                return WomensHealth;
              case "Doulas":
                return Doulas;
              case 'Gender-Affirming Support':
                return GenderAfirm;
              default:
                return console.log("no images found"); // Use a default fallback image if service type is unknown
            }
          };
          // Set carousel data from ServiceDetails
          const homeBlockData = ServiceDetails.map((service) => ({
            id: service.ServiceId,
            image: getServiceImage(service.ServiceDescription), // Use the function to get the corresponding image
            text: service.ServiceDescription,
            link: service.WebLink || "#",
            videolink: service.VideoLink
          }));
          setBlockData(homeBlockData);

          // Set HomeSections in state for displaying in the features section
          setHomeSections(HomeSections);
          setMemberReqAuth(data.TreatmentDetails?.MemberReqAuth || "No");
          // Set WebinarList in state for Upcoming Live Events
          setWebinarList(data.WebinarList || []);

          let quickActionsArr = (data.QuickActions || []).map((action) =>
            action.ServiceDetailDescription === "WIN Marketplace"
              ? {
                  ...action,
                  title: isHighmarkPortal
                    ? "Fertility and Family Building Marketplace"
                    : "WIN Marketplace",
                }
              : action
          );

          // Check if WINPay exists in HomeSections
          const winPaySection = (data.HomeSections || []).find(section => section.ServiceDescription === "WINPay");
          const rxSection = (data.HomeSections || []).find(section => section.ServiceDescription === "Prescriptions");
          const treatmentSection = (data.HomeSections || []).find(section => section.ServiceDescription === "Treatment");
          if (winPaySection && !quickActionsArr.some(q => q.ServiceDetailDescription === "WINPay")) {
            // Add WINPay to quick actions if not already present
            quickActionsArr = [
              ...quickActionsArr,
              {
                ServiceDetailId: winPaySection.ServiceId,
                ServiceDetailDescription: winPaySection.ServiceDescription,
                WebLink: winPaySection.WebLink,
                VideoLink: winPaySection.VideoLink,
                DocumentLink: winPaySection.DocumentLink,
                title: isHighmarkPortal ? "Pay" : "WINPay",
              },
            ];
          }

           if (rxSection) {
              quickActionsArr.push({
                ServiceDetailId: rxSection?.ServiceId,
                ServiceDetailDescription: rxSection?.ServiceDescription,
                WebLink: rxSection?.WebLink,
                VideoLink: rxSection?.VideoLink,
                DocumentLink: rxSection?.DocumentLink,
                title: "Rx Authorization",
              });
            }

            if (treatmentSection) {
              quickActionsArr.push({
                ServiceDetailId: treatmentSection?.ServiceId,
                ServiceDetailDescription: treatmentSection?.ServiceDescription,
                WebLink: treatmentSection?.WebLink,
                VideoLink: treatmentSection?.VideoLink,
                DocumentLink: treatmentSection?.DocumentLink,
                title: "Treatment Authorization",
              });
            }

          setQuickActions(quickActionsArr);          
          // Set WebinarRegistrationdetails in state for Appointments & Events
          setWebinarRegistrations(data.WebinarRegistrationdetails || []);
          // Set other data (appointments, treatment, etc.)
          if (AppoinmentDetails) {
            setAppointments({
              date: AppoinmentDetails?.ConsultationDate || null,
              time: AppoinmentDetails?.Time || null,
              duration: AppoinmentDetails?.TimerDuration || null,
              SlotType: AppoinmentDetails?.SlotType,
              TimeZoneName: AppoinmentDetails.TimeZoneName
            });
          }
          const truncateText = (text, maxLength = 80) => {
            return text?.length > maxLength ? text.slice(0, maxLength) + "..." : text;
          };

          // Set allAppointments from Appointments array (filter out canceled)
          if (Array.isArray(Appointments)) {
            const validAppointments = Appointments.filter(
              (appointment) => appointment.Status !== "Canceled"
            );
            setAllAppointments(validAppointments);
          } else {
            setAllAppointments([]);
          }

          if (TreatmentDetails) {
            setTreatmentStatus({
              description: truncateText(TreatmentDetails?.TreatmentDescription || "", 45),
              status: TreatmentDetails?.TreatmentStatus || "",
              requestedDate: TreatmentDetails?.TreatmentReqDate || "",
              MemberReqAuth: TreatmentDetails?.MemberReqAuth || "",
            });
            //response.data.TreatmentDetails.MemberReqAuth
          }

          if (PrescriptionDetails) {
            setPrescription({
              description: PrescriptionDetails?.DrugName || "",
              status: PrescriptionDetails?.DrugStatus || "",
              requestedDate: PrescriptionDetails?.ReqFromDate || "",
            });
          }

          if (WebinarLink) {
            setWebinarLink(WebinarLink);
          }

          if (EducationFeed) {
            setEducationLink(EducationFeed);
          }

        } catch (error) {
          console.error("Error fetching dashboard data:", error); // Log the error if API fails
        } finally {
          setIsLoading(false);
        }
      };

      fetchDashboardData();
    } else {
      // Redirect to login if email or token is missing
      navigate("/login");
    }
  }, [email, dispatch]); // Re-run when email changes

  useEffect(() => {
    if (userData?.userData?.userData?.WincardConsentFlag === "Y") {
      setShowMenopurModal(true);
    }
  }, [userData]);

const OidcIntegration =async(vendor)=>{
  const token = localStorage.getItem('AccessToken');
  const params = {
    emailId: email,
    vendor : vendor,
  };
  setLoading(true);
try {
  // Making the API call
  const response = await axios.post(
    Endpoints.OidcIntegration,
    `_Params=${encodeURIComponent(JSON.stringify(params))}`,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      }
    }
  );
  if (response?.data) {
    window.open(response?.data, "_blank");
  }
} catch (error) {
  console.error("Error during OIDC Integration:", error);
}   finally {
setLoading(false); // <-- Ensure loading is set to false after fetch
}
}

  function formatSelectedDateToMMDDYYYY(dateStr) {
    // Expects "30-Sep-2025"
    if (!dateStr) return "";
    const months = {
      Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
      Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12"
    };
    const [day, mon, year] = dateStr.split("-");
    return `${months[mon]}/${day}/${year}`;
  }


  // Adjust itemsPerView based on window width
  useEffect(() => {
    const updateItemsPerView = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 600) {
        setItemsPerView(1);
      } else if (screenWidth <= 900) {
        setItemsPerView(3);
      } else {
        setItemsPerView(5);
      }
    };

    updateItemsPerView();
    window.addEventListener("resize", updateItemsPerView);
    return () => window.removeEventListener("resize", updateItemsPerView);
  }, []);

  const scrollCarousel = (direction) => {
    const maxPosition = totalItems - itemsPerView;
    let newPosition = currentPosition + direction * scrollCount;

    if (newPosition < 0) {
      newPosition = 0;
    }

    if (newPosition > maxPosition) {
      newPosition = maxPosition;
    }

    setCurrentPosition(newPosition);
  };

  const offset = (currentPosition * 102) / itemsPerView;

  const handleActivityClick = async (activity, link, isExternal) => {
    const wincentiveparam = homeSections.some((homeSection) =>
      homeSection.ServiceDescription.includes("WINcentive Rewards"));
    const token = localStorage.getItem("AccessToken");
    const deviceType = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
    if (email && token) {
      try {
        const payload = `_Params=${encodeURIComponent(
          JSON.stringify({ EmailID: email, Activity: activity, DeviceType: deviceType })
        )}`;
        await axios.post(Endpoints.CallRecoderLog, payload, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        });

        // console.log(`${activity} activity logged successfully.`);
      } catch (error) {
        console.error(`Failed to log ${activity} activity:`, error);
      }
    }

    // Navigate to the respective link
    // Check if navigating to Treatment Page
    if (activity === "Treatment") {
      navigate(link, { state: { memberReqAuth } });
    } else if (activity === "WINPay") {
      navigate(link, { state: { wincentiveparam } }); // ✅ use from link
    } else if (isExternal) { // <-- Use the argument, not link.isExternal
      window.open(link, "_blank", "noopener,noreferrer");
    } else {
      navigate(link);
    }
  };

  const handleCarouselClick = (link) => {
    const updatedLink = {
      ...link,
      originalText: link.text, // Always preserve original
      displayText: (isHighmarkPortal && link.text === "WIN for Him")
        ? "Fertility and Family Building for Him"
        : link.text
      // link.text
    };

    navigate('/support-services', { state: updatedLink });
  };


  if (isLoading) {
    return <div className="loading-container">
      <div className="loading"></div>
      <h2 className="loading-text">{t("loading")}</h2>
    </div>;
  }

  const handleOkClick = () => {
    setShowModal(false);
    window.location.reload();
  };



  //Journey Message
  const whyHere =
    normalizeWhyHere(
      userData?.registration?.registrationData?.WhyHere ||
      userData?.userData?.userData?.WhyHere
    )
      .replace(/^I want\s*/i, '')
      .replace(/\s*support$/i, '')
      .trim();

  // Utility function for journey message
  function getJourneyMessage(whyHere) {
    const includes = (str, substr) => str.toLowerCase().includes(substr.toLowerCase());
    const why = whyHere.toLowerCase();
    if (includes(why, "pregnancy")) return "Not currently pregnant?";
    if (includes(why, "family-building")) return "Not currently seeking family-building support? ";
    if (includes(why, "menopause")) return "Not currently seeking menopause support? ";
    if (includes(why, "andropause")) return "Not currently seeking andropause support? ";
    if (includes(why, "caregiving")) return "Not currently seeking caregiving support? ";
    if (includes(why, "parenting and child development")) return "Not currently seeking child development and parenting support? ";
    if (includes(why, "women's health")) return "Not currently seeking women's health support? ";
    if (includes(why, "gender affirming")) return "Not currently seeking gender affirming support? ";
    return "Not currently seeking family building support ? ";
  }

  // Utility function to get journey image class
  function getJourneyImageClass(whyHere) {
    const why = whyHere.toLowerCase();
    if (why.includes("preconception")) return "j-img-preconception";
    if (why.includes("behavioral health")) return "j-img-behavioral_health";
    if (why.includes("nutrition")) return "j-img-nutrition";
    if (why.includes("child development")) return "j-img-child_development";
    if (why.includes("doulas")) return "j-img-doulas";
    if (why.includes("menopause")) return "j-img-menopause";
    if (why.includes("andropause")) return "j-img-andropause";
    if (why.includes("win for him")) return "j-img-win_for_him";
    if (why.includes("surrogacy")) return "j-img-surrogacy";
    if (why.includes("maternity")) return "j-img-maternity";
    if (why.includes("women's health")) return "j-img-womens_health";
    if (why.includes("lgbtqia")) return "j-img-lgbtqia";
    if (why.includes("adoption")) return "j-img-adoption";
    if (why.includes("caregiving")) return "j-img-caregiver_support ";
    if (why.includes("family-building")) return "j-img-fertility ";
    if (why.includes("gender affirming")) return "j-img-gender_affirming_support ";


    // Default image
    return "j-img-maternity";
  }

  const handlejournery = () => {
    dispatch(updateIsJourneyChange(true))
    navigate('/edit-healthprofilesetup', { state: { journeyChange: true } });
  };

  // Extract the tracker key dynamically
  const getImageClass = (imagePath) => {
    if (!imagePath) return '';
    const name = imagePath.split('/').pop().split('.')[0]; // e.g., Fertility.jpg → Fertility
    return `img-${name.replace(/\s+/g, '-').toLowerCase()}`; // kebab-case
  };


  // Handler for RSVP click on webinar event
  const handleWebinarRSVP = async (webinar) => {
    const deviceType = isHighmarkPortal ? "HighmarkPortal" : "PatientPortal";
    const payload = {
      WebinarId: webinar.id,
      uuid: webinar.uuid,
      FirstName: userData?.userData?.userData?.FirstName || userData?.registration?.registrationData?.FirstName || '',
      LastName: userData?.userData?.userData?.LastName || userData?.registration?.registrationData?.LastName || '',
      contract: userData?.userData?.userData?.ContractIdentified || userData?.registration?.registrationData?.ContractIdentified || '',
      Email: email,
      start_time: webinar.start_time,
      timeofstart: webinar.timeofstart,
      topic_header: webinar.topic_header,
      join_url: webinar.join_url,
      DeviceType: deviceType
    };
    try {
      const response = await axios.post(
        Endpoints.RegisterUserforWebinar,
        `_Params=${encodeURIComponent(JSON.stringify(payload))}`,
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${localStorage.getItem('AccessToken')}`,
          },
        }
      );
      if (response.data?.result === 0) {
        setModalMessage(response.data?.resultText || 'Webinar registration failed. Please try again.');
        setShowModal(true);
        return;
      }
      if (response.data?.result === 1) {
        setModalMessage(response.data?.resultText);
        setShowModal(true);
        return;
      }
    } catch (error) {
      setModalMessage('Webinar registration failed. Please try again.');
      setShowModal(true);
    }
  };

  const getServiceName = (whyHere) => {
    let serviceType = ""
    switch (whyHere) {
      case "I want parenting and child development support":
        serviceType = "Child Development";
        break;
      case "I want family-building support":
        serviceType = "Fertility";
        break;
      case "I want andropause (low Testosterone) support":
        serviceType = "Andropause";
        break;
      case "I want perimenopause or menopause support":
        serviceType = "Menopause";
        break;
      case "I want pregnancy support":
        serviceType = "Maternity";
        break;
    }

    return serviceType;
  }

// Quick Actions card click handler
const handleCardClick = (service) => {
  debugger;
  const ServiceDescription = service.ServiceDetailDescription;
  const displayServiceDescription = ServiceDescription;
  switch (ServiceDescription) {
    case "Connect with an Advocate":
      navigate("/book-appointment", { state: { servicedescription: getServiceName(journeyType)} });
      break;
    case "Explore Resources":
      loadCallRecoderLog(service);
      if (whyHere.toLowerCase().includes("child development")) {
        navigate("/child-development", { state: { link: service.WebLink } });
      } else {
        navigate("/feedServices", { state: { link: service.WebLink, description: isHighmarkPortal ? displayServiceDescription : ServiceDescription, videolink: service.VideoLink, documentlink: service.DocumentLink } });
      }
      break;
    case "Ovulation tracking bracelet":
      case "Pediatric Behavioral Health":
        if(whyHere.toLowerCase().includes("child development")){
          OidcIntegration("Bend");
           }else{
        window.open(service.WebLink, "_blank");
           }
        break;
        case "Pediatric Virtual Network":
          if(whyHere.toLowerCase().includes("child development")){
            navigate("/pediatric-care")
             }else{
          window.open(service.WebLink, "_blank");
             }
          break;
    case "At-home sperm testing kit":
      loadCallRecoderLog(service);
      window.open(service.WebLink, "_blank");
      break;
    case "WIN Virtual Network":
      if(whyHere.toLowerCase().includes("gender")){
      setShowVirtualNetworkModal(true);
      setVirtualNetworkLink(service.WebLink); 
      setModalMessage("You are being redirected to Gender Affirming, powered by Plume. Use coupon code WIN25 to access your benefit.");
      }else{
      window.open(service.WebLink, "_blank");
      }
      break;
    case "WIN Maternity powered by Ovia":
    case "WIN Maternity powered by Cleo":
      if (service.WebLink) {
        loadCallRecoderLog(service);
        window.open(service.WebLink, "_blank");
      }
      break;
    case "WIN Baby powered by Cleo":
    case "WIN Milk":
   case "WIN Communities":
    case "At Home Menopause Test":
      if (service.WebLink) {
        loadCallRecoderLog(service);
        getAndOpenMiraLink("Menopause", service.WebLink);
      }
      break;
      case "Breast Milk Shipping & Lactation Tools":
        OidcIntegration("Milkstork");
        break;
    case "Preeclampsia Genetic Testing":
      if (!service.WebLink) {
        setModalMessage(t("virtualnetworkmessage"));
        setShowModal(true);
      } else {
        loadCallRecoderLog(service);
        window.open(service.WebLink, "_blank");
      }
      break;
    case "Pregnancy Symptom Tracker":
      navigate("/pregnancy");
      break;
       case "WINPay": 
     navigate("/pay-landingpage");
      break; 
    case "Fertility Tracker":
      navigate("/fertility");
      break;
    case "Andropause Symptom Tracker":
      navigate("/andropause");
      break;
    case "Menopause Symptom Tracker":
      navigate("/menopause");
      break;
    case "Weekly Pregnancy Tracker":
      navigate("/weekly-pregnancy-tracker");
      break;
    case "Wincentive Rewards":
      navigate("/incentive-landingpage");
      break;
    case "Find Care":
      navigate("/load-findcare-list");
      break;
    case "Additional Coaching Support":
      if (service.WebLink) {
        loadCallRecoderLog(service);
        window.open(service.WebLink, "_blank");
      }
      break;
    case "At Home Ovulation Tracking":
      if (service.WebLink) {
        loadCallRecoderLog(service);
        getAndOpenMiraLink("Preconception", service.WebLink);
      }
      break;
       case "Expert Coaching":
      if (service.WebLink) {
        loadCallRecoderLog(service);
        window.open(service.WebLink, "_blank");
      }
      break;
       case "Pediatric Behavioral Health":
      if (service.WebLink) {
        loadCallRecoderLog(service);
        window.open(service.WebLink, "_blank");
      }
      break;
      case "Pediatric Virtual Network":
        if (service.WebLink) {
          loadCallRecoderLog(service);
          window.open(service.WebLink, "_blank");
        }
        break;
      case "Return to Work Support":
        navigate("/return-to-work-support");
        break;
      case "Prescriptions":
        navigate("/rx-authorization");
        break;
      case "Treatment":
        navigate("/treatment-authorization");
        break;
      case "WIN Marketplace":
      case "Fertility and Family Building Marketplace":
        navigate("/benefits-winmarketplace");
        break;        
      default:
          if (service.WebLink) {
    loadCallRecoderLog(service);
    window.open(service.WebLink, "_blank");
  }
        break;
    }
  };

  // Map for icon class names for Quick Actions
  const quickActionIconMap = {
    "Connect with an Advocate": "q-connect-with-nurse",
    "Weekly Pregnancy Progress": "q-wheekly-pregnancy-tracker",
    "Weekly Pregnancy Tracker": "q-wheekly-pregnancy-tracker",
    "Explore Resources": "q-explore-resources",
    "Articles for you": "q-explore-resources",
    "WIN Virtual Network": "q-win-virtual-network",
    "WIN Pediatric Behavioral Health": "q-win-virtual-network",
    "WIN 24/7 Pediatric Virtual Network": "q-win-virtual-network",
    "WIN Communities": "q-win-virtual-network",
    "Fertility Tracker": "q-fertility-tracker",
    "Ovulation tracking bracelet": "q-ovulation-tracking-bracelet",
    "Ovulation": "q-ovulation-tracking-bracelet",
    "At-home sperm testing kit": "q-homes-sperm-kit",
    "Home Sperm Kit": "q-homes-sperm-kit",
    "Pregnancy Symptom Tracker": "q-pregnancy-symptom-tracker",
    "Pregnancy": "q-pregnancy-symptom-tracker",
    "Menopause Symptom Tracker": "q-menopause-symptom-tracker",
    "Menopause": "q-menopause-symptom-tracker",
    "Andropause Symptom Tracker": "q-andropause-symptom-tracker",
    "Andropause": "q-andropause-symptom-tracker",
    "WIN Maternity powered by Cleo": "q-maternity-powered-by-cleo",
    "Cleo": "q-maternity-powered-by-cleo",
    "WIN Maternity powered by Ovia": "q-maternity-powered-by-ovia",
    "Ovia": "q-maternity-powered-by-ovia",
    "WINcentive Rewards": "q-wincentive-rewards",
    "Preeclampsia Genetic Testing": "q-preeclampsia-genetic-testing",
    "Genetic Testing": "q-preeclampsia-genetic-testing",
    "At Home Ovulation Tracking": "q-at-home-ovulation-tracking",
    "Ovulation Tracker": "q-at-home-ovulation-tracking",
    "Sperm Testing Kit": "q-sperm-testing-kit",
    "WINPay": "q-winpay-icon",
    "Pediatric Sleep Support": "q-pediatric-sleep-support",
    "WIN Baby powered by Cleo": "q-win-virtual-network",
    "Breast Milk Shipping & Lactation Tools": "q-breast-milk-shipping",
    "Prescriptions": "q-rx-authorization",
    "Treatment": "q-treatment-authorization",
    "WIN Marketplace": "q-win-marketplace",
    "Fertility and Family Building Marketplace": "q-win-marketplace",
  };

  // Dummy for loadCallRecoderLog (implement as needed)
  const loadCallRecoderLog = (service) => {
    // ...implement API call or logging as needed...
  };
  const isAppointmentTimeNow = (appointmentTime, appointmentDate, appointmentTimeZone, appointmentOffsetDiff) => {
    // Combine the date and time into a single string, assuming the appointmentDate is in a proper format
    const dateString = `${appointmentDate} ${appointmentTime} ${appointmentOffsetDiff}`;

    // Try creating a new Date object and check for validity
    const appointmentDateTime = new Date(dateString);
    const currentTime = new Date();
    return currentTime >= appointmentDateTime;
  };

  const providerAppointments = allAppointments.filter((appt) => appt.ProviderName);
  const consultAppointments = allAppointments.filter((appt) => !appt.ProviderName);

  const handleJoinClick = (appointment) => {
    console.log(appointment);
    pauseSession();
    const roomname = appointment.VideoRoomName
    navigate("/patientconsultation", { state: { roomname } })
  }

  const handleReschedule = (appointment) => {
    if (appointment.ProviderName) {
      // Navigate to AddAppointmentPage with appointment object in state
      navigate("/AddAppointmentPage", { state: { appointment, isRescheduling: true } });
    } else {
      // Navigate to book-appointment page
      navigate("/book-appointment", { state: { ...appointment, isRescheduling: true } });
    }
  };


  const handleCancel = (appointment) => {
    // Show confirmation modal before canceling
    setAppointmentToCancel(appointment);
    setModalMessage("Are you sure you would like to cancel the appointment?");
    setShowCancelModal(true);
  };

  const handleProviderSearch = (appointment) => {
    const { ProviderName, Address, City, State, ZipCode } = appointment;

    // Combine into full address
    const fullAddress = `${ProviderName},${Address}, ${City}, ${State} ${ZipCode}`;

    // Encode it for URL
    const encodedAddress = encodeURIComponent(fullAddress);
    // Create the Google Maps URL
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

    // Open in a new tab
    window.open(googleMapsUrl, '_blank');

  }

  const confirmCancellation = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("AccessToken");
      const isProviderAppointment = appointmentToCancel?.ProviderName; // Distinguish the API endpoint

      const params = isProviderAppointment
        ? {
          SelectedDate: appointmentToCancel.SelectedDate,
          State: appointmentToCancel.State,
          ProviderName: appointmentToCancel.ProviderName,
          Action: "Cancel",
          Contract: userInfo.userData.ContractIdentified,
          Address: appointmentToCancel.Address,
          EditedDate: "",
          SelectedTime: appointmentToCancel.Time,
          MemberID: appointmentToCancel.MemberID,
          ZipCode: appointmentToCancel.ZipCode,
          City: appointmentToCancel.City,
          EditedTime: "",
          DeviceType: deviceType,
          EmailID: email
        }
        : {
          Time: appointmentToCancel.Time,
          OffSet: appointmentToCancel.OffSet,
          TimeZoneName: appointmentToCancel.TimeZoneName,
          SlotType: appointmentToCancel.SlotType,
          Text: "Booked",
          SelectedDate: appointmentToCancel.SelectedDate,
          UserName: "MAPP",
          CalendarType: "All",
          Email: emailId,
          OffsetDiff: appointmentToCancel.OffsetDiff,
          DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
        };

      const endpoint = isProviderAppointment
        ? Endpoints.providerappointment
        : Endpoints.confirmCancellation;

      const response = await axios.post(
        endpoint,
        isProviderAppointment
          ? `_Params=${encodeURIComponent(JSON.stringify(params))}`
          : { _Params: JSON.stringify(params) },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Authorization": `Bearer ${token}`,
          },
        }
      );
      if (
        (response.data?.Result === 1)
      ) {
        // Remove canceled appointment
        setAllAppointments((prevAppointments) =>
          prevAppointments.filter(
            (appt) =>
              appt.SelectedDate !== appointmentToCancel.SelectedDate ||
              appt.Time !== appointmentToCancel.Time
          )
        );
      } else if (response.data?.Result === 2) {
        setShowModal(true);
        setModalMessage(response.data?.Data);
      } else {
        console.error("Failed to cancel appointment:", response.data);
        alert(response.data?.Message || t("Failed to cancel appointment."));
      }
    } catch (error) {
      console.error("Error canceling appointment:", error);
    } finally {
      // Reset modal state
      setShowCancelModal(false);
      setAppointmentToCancel(null);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }
console.log(appointments || appointments == null)
  // Defensive: treat null as empty array for webinarRegistrations
  const safeWebinarRegistrations = Array.isArray(webinarRegistrations) ? webinarRegistrations : [];

  return (
    <>
      {/* Carousel Section */}

      {/* <div> */}

      <div className="home-page-note-wrapper-c">
        <p className="mb-0">
          <strong className="welcome-heading page-heading-bold-primary-20 font-poppins text-white">WELCOME, {preferredName !== "" ? preferredName : firstName}</strong>
          <br />
          <p className="note-text mb-0 mt-2 highmark-font-size-16px">
            We're here to help you navigate your {whyHere} journey.
          </p>
          <p className="note-subtext mb-0 mt-2 highmark-font-size-16px" onClick={handlejournery}>

            {getJourneyMessage(whyHere)}  You can change your journey anytime. <i className="bi bi-pencil-square me-2"></i>
          </p>
        </p>
      </div>

      {(dashboardData?.BookAppointment === "Y" && webinarRegistrations.length === 0 && (allAppointments.length === 0 )) && (
        <div className="home-page-note-wrapper-e">
          {/* Image + Text on the left */}
          <div className="nurse-advocate-content">
            <div className="nurse-advocate-image" />
            <p className="mb-0">
              <strong className="page-heading-bold-primary-20 font-poppins highmark-dark-heading">
                Meet with your Nurse Care Advocate.
              </strong>
              <br />
              Get 1:1 clinical support and guidance through every step of your journey.
            </p>
          </div>

          {/* Button on the right */}
          <button
            className="win-btn-secondary-h mt-3 mt-md-0 responsive-btn"
            onClick={handleBookConsultClick}
          >
            Book a Virtual Consult
          </button>
        </div>
      )}
      <AddAppointmentModal
        show={showAppointmentModal}
        onClose={handleClose}
        onYes={handleYes}
        onYesNoLongerPregnant={handleYesNoLongerPregnant}
        onNo={handleNo}
      />

      <div class="appointments-container">
        {(dashboardData?.BookAppointment ==="Y" && (safeWebinarRegistrations.length > 0|| allAppointments.length > 0) ) && (
          isHighmarkPortal ?
            <h5 class="mb-3 fw-semibold">Your Appointments</h5>
            : (dashboardData?.BookAppointment === "N" && safeWebinarRegistrations.length > 0) ?
              <h5 class="mb-3 fw-semibold">Your Events</h5>
              : (
                <h5 class="mb-3 fw-semibold">Your Appointments & Events</h5>
              )
        )}
        <div class="appointment-scroll-wrapper">
          {( dashboardData?.BookAppointment === "Y" && (allAppointments.length > 0 || safeWebinarRegistrations.length > 0) ) && (
            <div className="add-appointment" onClick={handleBookConsultClick} style={{ cursor: 'pointer' }}>
              <div>+<br />add an<br />appointment</div>
            </div>
          )}

          {dashboardData?.BookAppointment === "Y" && (
            <>
              {/* Map Consult Appointments */}
              {consultAppointments.map((appt, idx) => (
                <div className="appointment-box" key={`consult-${idx}`}>
                  <div className="appointment-content">
                    <div className="appointment-header">{appt.SlotType}</div>
                    {/* <div className="appointment-time">({appt.TimerDuration || "30"} minutes)</div> */}
                    <div className="appointment-time">({"30"} minutes)</div>

                    <div className="appointment-time mt-0">
                      {formatSelectedDateToMMDDYYYY(appt.SelectedDate)}<br />{appt.Time}
                    </div>
                  </div>
                  <div className="btn-group">
                    {isAppointmentTimeNow(
                      appt.Time,
                      appt.SelectedDate,
                      appt.TimeZoneName,
                      appt.OffsetDiff
                    ) ? (
                      <button class="btn-join-now" onClick={() => handleJoinClick(appt)}>Join Now</button>
                    ) : (
                      <>
                        <button className="btn-reschedule" onClick={() => handleReschedule(appt)}>Reschedule</button>
                        <button className="btn-cancel" onClick={() => handleCancel(appt)}>Cancel</button>
                      </>
                    )}
                  </div>
                </div>
              ))}


              {/* Map Provider Appointments */}
              {providerAppointments.map((appt, idx) => (
                <div className="appointment-box" key={`provider-${idx}`}>
                  <div className="appointment-content">
                    <div className="appointment-header">{appt.ProviderName}</div>
                    {/* <div className="appointment-time">({appt.TimerDuration || "30"} minutes)</div> */}
                    <div className="appointment-time">({"30"} minutes)</div>
                    <div className="appointment-time mt-0">
                      {formatSelectedDateToMMDDYYYY(appt.SelectedDate)}<br />{appt.Time}
                    </div>
                  </div>
                  <div className="appointment-actions">
                    <div className="btn-group">
                      <button className="btn-maps" onClick={() => handleProviderSearch(appt)}>Show in Maps</button>
                    </div>
                    <div className="btn-group">
                      <button className="btn-reschedule" onClick={() => handleReschedule(appt)}>Reschedule</button>
                      <button className="btn-cancel" onClick={() => handleCancel(appt)}>Cancel</button>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}

          {/* Map Webinar Registrations */}
          {webinarRegistrations.map((webinar, idx) => {
            // Parse start_time if available
            let date = webinar.dateofstart || webinar.SelectedDate;
            let time = webinar.timeofstart || webinar.Time;
            // let duration = webinar.TimerDuration || "60 minutes";
            let duration = "60";
            if (webinar.start_time) {
              // Example: "11-12-2025 03:00 PM"
              const match = webinar.start_time.match(/^(\d{2}-\d{2}-\d{4})\s+([\d:]+\s*[APMapm]{2})$/);
              if (match) {
                date = match[1];
                time = match[2];
              }
            }
            // Format date from MM-DD-YYYY to MM/DD/YYYY
            let formattedDate = date;
            if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
              const [mm, dd, yyyy] = date.split('-');
              formattedDate = `${mm}/${dd}/${yyyy}`;
            }
            return (
              <div className="appointment-box" key={`webinar-${idx}`}>
                <div className="appointment-content">
                  <div className="appointment-header">{webinar.topic_header || webinar.WebinarTitle || 'Webinar'}</div>
                  {duration && (
                    <div className="appointment-time mt-0">({duration} minutes)</div>
                  )}
                  <div className="appointment-time">{formattedDate}</div>
                  <div className="appointment-time mt-0">{time}</div>

                </div>
                {(webinar.TimerDuration <= 0) ? (
                  <div className="btn-group">
                    <button className="btn-reschedule" onClick={() => window.open(webinar.join_url, '_blank', 'noopener,noreferrer')}>Join</button>
                  </div>
                ) : null}
              </div>
            );
          })}

        </div>
      </div>



      {/* Journey Image */}
      <div className="home-page-note-wrapper-e">
        <img className={`journey-image ${getJourneyImageClass(whyHere)}`} />
      </div>

      {/* Quick Actions */}
      <div className="quick-actions-container">
        <h5 className="mb-3 fw-semibold">Quick Actions</h5>
        <div className="row g-3">
          {quickActions
            .map((service, idx) => (
              <div className="col-6 col-md-3" key={idx}>
                <div className="quick-action-card" onClick={() => handleCardClick(service)} style={{ cursor: 'pointer' }}>
                  <div className={`quick-action-icons ${quickActionIconMap[service.ServiceDetailDescription] || `q-${service.ServiceDetailDescription.replace(/\s+/g, '-').toLowerCase()}`}`} />
                  <div className="quick-action-label">{service.title || service.ServiceDetailDescription}</div>
                </div>
              </div>
            ))}
        </div>
      </div>


      <div className="carousel-container">
        <h5>Additional Support</h5>
        <div
          className="home-carousel-inner"
          style={{ transform: `translateX(-${offset}%)` }}
        >

          {blockData.map((block) => (
            <div
              key={block.id}
              className="home-carousel-item"
              onClick={() => handleCarouselClick(block)} // Trigger click event
              style={{ cursor: "pointer" }} // Change cursor to indicate clickability
            >
              <div className={`carousel-image ${getImageClass(block.image)}`} />
              {/* <img
                src={block.image}
                alt={`Image ${block.id}`}
                className="carousel-image"
              /> */}
              <div className="carousel-text">
                {(isHighmarkPortal && block.text === "WIN for Him")
                  ? "Fertility and Family Building for Him" // make sure this exists in your i18n JSON
                  : block.text}
              </div>
            </div>
          ))}
        </div>        <div className="home-carousel-controls">          <button
          className={`btn-custom-carousel-arrows${currentPosition === 0 ? ' btn-disabled' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            if (currentPosition > 0) {
              handleArrowClick(-1);
            }
          }}
          onTouchStart={(e) => {
            e.preventDefault();
            if (currentPosition > 0) {
              e.currentTarget.classList.add('active');
            }
          }}
          onTouchEnd={(e) => {
            e.preventDefault();
            const button = e.currentTarget;
            button.classList.remove('active');
            if (currentPosition > 0) {
              handleArrowClick(-1);
            }
          }}
          onTouchCancel={(e) => {
            e.preventDefault();
            e.currentTarget.classList.remove('active');
          }}
          disabled={currentPosition === 0}
          aria-label="Previous slide"
        >
          {/* button content */}
        </button>
          <button
            className={`btn-custom-carousel-arrows${currentPosition >= totalItems - itemsPerView ? ' btn-disabled' : ''}`}
            onClick={(e) => {
              e.preventDefault();
              if (currentPosition < totalItems - itemsPerView) {
                handleArrowClick(1);
              }
            }}
            onTouchStart={(e) => {
              e.preventDefault();
              if (currentPosition < totalItems - itemsPerView) {
                e.currentTarget.classList.add('active');
              }
            }}
            onTouchEnd={(e) => {
              e.preventDefault();
              const button = e.currentTarget;
              button.classList.remove('active');
              if (currentPosition < totalItems - itemsPerView) {
                handleArrowClick(1);
              }
            }}
            onTouchCancel={(e) => {
              e.preventDefault();
              e.currentTarget.classList.remove('active');
            }}
            disabled={currentPosition >= totalItems - itemsPerView}
            aria-label="Next slide"
          >
            {/* button content */}
          </button>
        </div>

      </div>



      {/* Upcoming Live Events */}
      {!isHighmarkPortal && <div className="events-container">
        <h5 className="mb-3 fw-semibold">Upcoming Live Events</h5>
        <div class="appointments-scroll-wrapper">
          {Array.isArray(webinarList) && webinarList.map((webinar, idx) => (
            <div className={idx === 0 ? "event-card highlight" : "event-card"} key={webinar.id || idx}>
              <div>
                <div className="event-date">{webinar.dateofstart}</div>
                <div className="event-time">{webinar.timeofstart}</div>
                <div className="event-title">{webinar.topic_header}</div>
                <div className="event-desc">{webinar.topic_subheader}</div>
              </div>
              <button className="btn-rsvp mt-auto" onClick={() => handleWebinarRSVP(webinar)}>RSVP</button>
            </div>
          ))}
        </div>
      </div>}




      {/* Features Section */}
      <ErrorModal
        show={showModal}
        message={modalMessage}
        onClose={() => setShowModal(false)}
        isOkay={true}
        onOkay={handleOkClick}
      />

      <ErrorModal
        show={showCancelModal}
        message={modalMessage}
        isCancellationSelected={true}
        onClose={() => {
          setShowCancelModal(false);
          setAppointmentToCancel(null);
        }}
        onOkay={confirmCancellation}
      />

      <MenopurModal
        isOpen={showMenopurModal}
        onClose={() => setShowMenopurModal(false)}
      />

      {/* Virtual Network Modal */}
      <ErrorModal
        show={showVirtualNetworkModal}
        message={modalMessage}
        isOkay={true}
        onOkay={() => {
          setShowVirtualNetworkModal(false);
          if (virtualNetworkLink) {
            window.open(virtualNetworkLink, "_blank", "noopener,noreferrer");
          }
        }}
        onClose={() => setShowVirtualNetworkModal(false)}
      />

      <FeedbackConsent 
        isOpen={showFeedbackConsent}
        onClose={closeModal}
        token={token}
        deviceType={isHighmarkPortal ? "HighmarkPortal" : "PatientPortal"}
        email={email}
      />
    </>
  );
};

export default Home_W;
